// src/app/shared/components/delegation-dropdown/delegation-dropdown.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../core/auth/auth.service';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DelegationInfo, DelegationState } from '@shared/model/delegation.model';

@Component({
  standalone: true,
  selector: 'app-delegation-dropdown',
  templateUrl: './delegation-dropdown.component.html',
  styleUrls: ['./delegation-dropdown.component.scss'],
  imports: [
    CommonModule,
    NgbDropdownModule
  ]
})
export class DelegationDropdownComponent implements OnInit, OnDestroy {
  
  // Component state
  isAuthenticated = false;
  isDelegating = false;
  currentDelegation: DelegationState | null = null;
  availableDelegations: DelegationInfo[] = [];
  
  private destroy$ = new Subject<void>();
  
  constructor(private authService: AuthService) {}
  
  ngOnInit() {
    this.subscribeToAuthState();
    this.subscribeToDelegationState();
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
  private subscribeToAuthState() {
    this.authService.getProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe(profile => {
        this.isAuthenticated = !!profile;
        
        if (this.isAuthenticated && !this.isDelegating) {
          this.loadAvailableDelegations();
        }
      });
  }
  
  private subscribeToDelegationState() {
    this.authService.getIsDelegating()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isDelegating => {
        this.isDelegating = isDelegating;
        
        // if (!isDelegating) {
        //   // Reload available delegations when switching back
        //   this.loadAvailableDelegations();
        // }
      });
    
    this.authService.getDelegationState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(delegationState => {
        this.currentDelegation = delegationState;
      });
  }
  
  private loadAvailableDelegations() {
    if (!this.isAuthenticated) return;
    
    
    this.authService.getAvailableDelegations().subscribe({
      next: (delegations) => {
        this.availableDelegations = delegations;
      },
      error: (error) => {
        this.availableDelegations = [];
      }
    });
  }
  
  // Component actions
  switchToDelegation(delegation: DelegationInfo) {
    if (delegation.delegationId === this.currentDelegation?.delegationId) {
      return; // Already using this delegation
    }
    
    
    this.authService.switchToDelegation(delegation.delegationId).subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.error('Failed to switch to delegation:', error);
        alert('Failed to switch user. Please try again.');
      }
    });
  }
  
  switchBackToOriginal() {
    
    this.authService.switchBackToOriginal().subscribe({
      next: () => {
      },
      error: (error) => {
        console.error('Failed to switch back to original user:', error);
        alert('Failed to return to original user. Please try again.');
      }
    });
  }
  
  hasAvailableDelegations(): boolean {
    return this.availableDelegations.length > 0;
  }
  
  isCurrentDelegation(delegation: DelegationInfo): boolean {
    return delegation.delegationId === this.currentDelegation?.delegationId;
  }
  
  trackByDelegationId(index: number, delegation: DelegationInfo): string {
    return delegation.delegationId;
  }
}
